module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAU9JREFUSA1jYBgFoyFA0xCYO3eu/vz58yVwWbJq1SqeWbNmWeGSB4kz4ZIEaf7z58/p379/XwUaYoCubtGiRWIfPnw48f///6P4LMFpQVhY2BdGRsZNQAOEgIbvRbZk3rx5oj9+/NgHlNMGqrkqICBwCd0BMD4jjIGNnjlzJivQgNVAg/yB9DugGmcWFpanQJ/thxkO5DsmJSW9xqYfJIbXApACLJa8BBquCXI5IcOJsgDJknVAg33AmhgZrwMNt8fncpA6EMAZBxBpCMnKyioAZCkiiYkDg0kaiY+TSdACUIQihzkwaLYAfYIR8bhswGsBuuGgMAcaHgS0ZCOxluC0AGgAEzAP7AbS4KQIi9D09PTfQLFQZEvwZUacFgDTPQfQ2zJAgy7ADIcFA5Ila4GW8f77908cJkcSDUyiXCCf4NMEyvH45EflRkOA8hAAABGJs6n60rqNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/CourseCenter/img/bread_close_gray.png
// module id = 1019
// module chunks = 1